import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const loginUser = async (email, password) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/login`, { email, password });
        console.log("Login response:", response.data);

        if (response.data && response.data.user) {
            return {
                success: true,
                data: {
                    ...response.data.user,
                    token: response.data.token || '',
                    package_type: response.data.user.package_type || 'basic'
                },
            };
        }

        throw new Error('Invalid response format');
    } catch (error) {
        console.error(error.response?.data);
        return {
            success: false,
            error: error.response?.data?.error || "Login failed",
        };
    }
};

export const validateLoginText = async (loginText) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/validatelogintext`, { loginText });
        console.log("Login response:", response.data);

        return response.data;

    } catch (error) {
        console.error(error.response?.data);
        return {
            success: false,
            error: error.response?.data?.error || "Login failed",
        };
    }
};

export const sendVerificationEmail = async ({ institution, enrollmentId, password, user_id }) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/validatelogin`,
            {
                loginText: institution,
                enrollmentId: enrollmentId,
                password: password,   // ✅ send password to backend
                user_id: user_id
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error validating login text:", error);

        if (error.response) {
            return error.response.data;
        }

        throw error;
    }
};

// service/forgotpassword.js

export const verifyEmailToken = async (token) => {
    try {
        const response = await fetch(
            `${API_BASE_URL}/verify-email?token=${token}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        const data = await response.json();

        return {
            success: response.ok && data.success,
            data: data,
        };
    } catch (error) {
        console.error("Verify email service error:", error);
        return {
            success: false,
            error: "Network error",
        };
    }
};
